import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import type { ComponentType } from 'react'

import '../../assets/stylesheets/inertia.css'
import { capturePageview } from '@/lib/posthog'

const pages = import.meta.glob<{ default: ComponentType }>('../pages/**/*.tsx')

void createInertiaApp({
  title: (title) => (title ? `${title} | Virtual Dash` : 'Virtual Dash'),
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) throw new Error(`Unknown Inertia page: ${name}`)
    return page().then((module) => module.default)
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
  progress: { color: '#20a4f3', showSpinner: true },
  defaults: {
    form: { forceIndicesArrayFormatInFormData: false, withAllErrors: true },
    visitOptions: () => ({ queryStringArrayFormat: 'brackets' }),
  },
})

router.on('navigate', (event) => {
  const config = event.detail.page.props.posthog as { session_recording?: boolean } | undefined
  capturePageview(event.detail.page.url, Boolean(config?.session_recording))
})
